import { computed } from 'vue'

import i18n from '@/libs/i18n'

export enum FilterTypes {
    Text        = 1,
    Number      = 2,
    Date        = 3,
    Select      = 4,
    MultiSelect = 5,
    Boolean     = 6,
}

export const PredefinedText = computed(() => ({
    AddSuccess:  i18n.global.t('success.add'),
    EditSuccess: i18n.global.t('success.edit'),
    ErrorOnAdd:  i18n.global.t('errors.on_add'),
    ErrorOnEdit: i18n.global.t('errors.on_edit'),
    ErrorOnLoad: i18n.global.t('errors.on_load'),
}))

/** How much fits on a screen. Remembered per browser under `density`. */
export enum Density {
    Compact = 'compact',
    Normal  = 'normal',
}
